import React, { useState } from 'react';
import logo from '../../assets/img/logo.png';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import Btn, { BtnRow } from '../../components/Btn/Btn';
import { sendMobileToServer, verifyMobileNo } from './_login_srv'
import { AppAlert } from '../../utils/index';
import {connect} from 'react-redux';
import AuthActions from '../../store/global/AccountingActions';
import {fixNumbers} from '../../utils';

import './login.css'

function LoginPage({setAuth}) {
    const [mobNumber, setMobNumber] = useState('')
    const [verifCode, setVerifCode] = useState('')
    const [isCodeSent, setIsCodeSent] = useState(false)

    const submitLogin = (e) => {
        e.preventDefault()
        if (isCodeSent === false) {
            if (mobNumber !== '') {
                sendMobileToServer(mobNumber).then(res => {
                    if (res.status === 200) {
                        AppAlert(200, 'لطفا کد تایید ارسالی به شماره تلفن همراهتان را وارد کنید')
                        setIsCodeSent(true)
                    }
                }).catch(err => {
                    console.log(err.response)
                    if(err.response){
                        AppAlert(err.response.status, err.response.data)
                    }else{
                        AppAlert(500, 'اشکال در سرور. با مدیر سامانه تماس بگیرید')
                    }
                })
            } else {
                AppAlert(400, 'لطفا شماره تلفن صحیح را وارد نمایید')
            }
        } else {
            if (verifCode !== '') {
                verifyMobileNo(mobNumber, verifCode).then(res=>{
                    if(res.status === 200){
                        AppAlert(200, 'لطفا کد تایید ارسالی به شماره تلفن همراهتان را وارد کنید')
                        if(res.data.token){
                            localStorage.setItem('accessToken', res.data.token);
                            setAuth()
                        }
                    }
                }).catch(err=>{
                    AppAlert(403, 'کد تایید صحیح نیست')
                })
            } else {
                AppAlert(400, 'لطفا کد تایید را وارد نمایید')
            }
        }
    }

    return (
        <div className="loginContainer">
            <div id="loginBox">
                <img src={logo} alt="" id="loginLogo" />
                <Form onSubmit={submitLogin}>
                    <FormGroup>
                        {/* <Label for="email">ایمیل</Label> */}
                        <Label>ورود به سامانه</Label>
                        <Input
                            type="mobile"
                            name="mobile"
                            id="phoneNumber"
                            disabled={isCodeSent}
                            placeholder="شماره تلفن همراه"
                            value={mobNumber}
                            onChange={(event) => setMobNumber(fixNumbers(event.currentTarget.value))}
                        />
                        {
                            isCodeSent ?
                                <Input
                                    name="verifCode"
                                    id="verifCode"
                                    placeholder="کد تایید"
                                    value={verifCode}
                                    onChange={(event) => setVerifCode(fixNumbers(event.currentTarget.value))}
                                    style={{marginTop: '1rem'}}
                                /> : null
                        }
                        <BtnRow Center>
                    <Btn>{isCodeSent ? 'ورود به سامانه' : 'دریافت کد تایید'}</Btn>
                        </BtnRow>
                    </FormGroup>
                </Form>
            </div>
        </div>
    )
}

const mapStateToProps = state =>{
    return{

    }
}


export default connect(mapStateToProps, AuthActions)(LoginPage);